import { createAction } from './util';

// pagination
export const initPagination = createAction('initPagination');
export const goToPage = createAction('goToPage');
export const setPageSize = createAction('setPageSize');

// filtering
export const registerFilter = createAction('registerFilter');
export const updateFilter = createAction('updateFilter', (key, value) => ({
  key,
  value
}));
export const resetFilter = createAction('resetFilter');
export const resetAllFilters = createAction('resetAllFilters');

// sorting
export const setSort = createAction('setSort');